var _defs, _rect, _rect2, _g, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gridGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00D4AA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#00D4AA",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00D4AA",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00D4AA",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00D4AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 60,
    height: 60,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 60 0 L 0 0 0 60",
    fill: "none",
    stroke: "#00D4AA",
    strokeWidth: 0.5,
    strokeOpacity: 0.1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#0A0A0F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#grid)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "960,100 1100,180 1100,340 960,420 820,340 820,180",
    fill: "none",
    stroke: "url(#accentGradient)",
    strokeWidth: 1,
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400,300 500,358 500,474 400,532 300,474 300,358",
    fill: "none",
    stroke: "#00D4AA",
    strokeWidth: 0.5,
    strokeOpacity: 0.15
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1500,400 1600,458 1600,574 1500,632 1400,574 1400,458",
    fill: "none",
    stroke: "#00D4AA",
    strokeWidth: 0.5,
    strokeOpacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 532,
    x2: 820,
    y2: 340,
    stroke: "#00D4AA",
    strokeWidth: 0.5,
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 340,
    x2: 1400,
    y2: 458,
    stroke: "#00D4AA",
    strokeWidth: 0.5,
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 420,
    x2: 960,
    y2: 700,
    stroke: "#00D4AA",
    strokeWidth: 0.5,
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 100,
    r: 3,
    fill: "#00D4AA",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1100,
    cy: 340,
    r: 2,
    fill: "#00D4AA",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 340,
    r: 2,
    fill: "#00D4AA",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 300,
    r: 2,
    fill: "#00D4AA",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1500,
    cy: 400,
    r: 2,
    fill: "#00D4AA",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100 600 L 200 600 L 200 500 L 350 500",
    fill: "none",
    stroke: "#00D4AA",
    strokeWidth: 0.5,
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1700 200 L 1700 350 L 1550 350 L 1550 450",
    fill: "none",
    stroke: "#00D4AA",
    strokeWidth: 0.5,
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 150 800 L 300 800 L 300 750 L 500 750 L 500 650",
    fill: "none",
    stroke: "#00D4AA",
    strokeWidth: 0.5,
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1800 700 L 1650 700 L 1650 600 L 1450 600",
    fill: "none",
    stroke: "#00D4AA",
    strokeWidth: 0.5,
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 200,
    width: 20,
    height: 20,
    fill: "none",
    stroke: "#00D4AA",
    strokeWidth: 0.5,
    strokeOpacity: 0.1,
    transform: "rotate(45, 210, 210)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1700,
    y: 500,
    width: 15,
    height: 15,
    fill: "none",
    stroke: "#00D4AA",
    strokeWidth: 0.5,
    strokeOpacity: 0.1,
    transform: "rotate(45, 1707.5, 507.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 800,
    width: 25,
    height: 25,
    fill: "none",
    stroke: "#00D4AA",
    strokeWidth: 0.5,
    strokeOpacity: 0.08,
    transform: "rotate(45, 612.5, 812.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1300,
    y: 150,
    width: 18,
    height: 18,
    fill: "none",
    stroke: "#00D4AA",
    strokeWidth: 0.5,
    strokeOpacity: 0.1,
    transform: "rotate(45, 1309, 159)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 960,
    cy: 400,
    rx: 600,
    ry: 400,
    fill: "url(#accentGradient)",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg);
export default __webpack_public_path__ + "static/media/hero-bg.816940104fcf8eb3105c590fb7eba58f.svg";
export { ForwardRef as ReactComponent };